import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LandingPage from "./components/LandingPage";


function App() {
    return (
        <div className="App">
            <LandingPage />
        </div>
    );
}

export default App;
